


import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { formatText } from 'src/app/shared/commen-function-file';
import { SharedService } from 'src/app/service/shared/shared.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-elcm-logs',
  templateUrl: './elcm-logs.component.html',
  styleUrls: ['./elcm-logs.component.scss'],
})
export class ElcmLogsComponent implements OnInit {

  buttonColorName: any
  updateLogsData: any = [];
  deleteLogsData: any = [];
  selectedTypeTabIndex: any;
  selectedTypeTabName: any = 'Updated Elcm Offer';
  EmployeeSummaryData: any;
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  loggedInCompanyFiscalyear: any | null;
  pmsYears: any = []
  selectedYearForCompetency: any = null;
  fromYear: any;
  toYear: any;

  constructor(public sharedService: SharedService, public router: Router, private httpService: HttpService, private config: Config, private encryptionService: EncryptionService) { }

  ngOnInit() {

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');

    this.getpmsyearlist();


    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');

    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

  }
  formatedataVariable = formatText;
  previousPage() {
    this.router.navigate(['/home/hrportal/asset-management']);
  }
  onClickVariablePaySetup(event: any) { }
  nextPage() {

  }
  onClickBreadcrumExpence() {
    this.router.navigate(['/home/hrportal/elcm']);

  }

  tableDataDetails: any = [];
  onSortAssending(sortKey: any): void {
 console.log(sortKey);
 
    this.updateLogs.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] < b[sortKey]) return -1;
      if (a[sortKey] > b[sortKey]) return 1;
      return 0;
    });
    
  }
  onSortDesending(sortKey: any): void {
     console.log(sortKey);
 
    this.updateLogs.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] > b[sortKey]) return -1;
      if (a[sortKey] < b[sortKey]) return 1;
      return 0;
    });
    
  }

  tabTypeChanged(event: MatTabChangeEvent) {
    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;


    if (this.selectedTypeTabName == 'Updated Elcm Exit') {

      this.viewLogsDetails();
    } else {
      
    }

  }



  exitColumnHeaderInfo = [
    { label: 'Field', isMandatory: false, sortingName: 'fieldName' },  
    { label: 'Band', isMandatory: false, sortingName: 'band' },
    { label: 'Grade', isMandatory: false, sortingName: 'grade' },
    { label: 'Old Value', isMandatory: false, sortingName: 'oldValue' },
    { label: 'New Value', isMandatory: false, sortingName: 'newValue' },
    { label: 'Changed By', isMandatory: false, sortingName: 'createdAt' },
    { label: 'Changed On', isMandatory: false, sortingName: 'updatedAt' }
  ];
  taskDeletedHeaderInfo = [
    { label: 'Asset Department Name', isMandatory: true, sortingName: 'assetDepartmentName' },
    { label: 'Delete Date', isMandatory: true, sortingName: 'createdAt' },
    { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
    { label: 'Fiscal Year', isMandatory: true, sortingName: 'year' },
    { label: 'Year', isMandatory: true, sortingName: 'year' },
    { label: 'Asset Name', isMandatory: true, sortingName: 'assetName' },
    { label: 'Bands', isMandatory: true, sortingName: 'bands' },
    { label: 'Authority Name', isMandatory: true, sortingName: 'authorityName' },
    { label: 'Authority Department', isMandatory: true, sortingName: 'authorityDepartment' },
  ];

  apiYear: any;

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(yearValue);

    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;
      console.log(this.selectedYearForCompetency);


      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
    }
  }

  //viewReimbursementByYear
  changeByYear(year: any) {
    this.selectedYearForCompetency = year;
    if (this.selectedTypeTabName == 'Updated Elcm Exit') {

      this.viewLogsDetails();
    } else {
    
    }
  }
  pageNo = 1;
  pageSizes = 25;
  updateLogs: any = []
DislaySelectedRecord(event:any){
  console.log(event);
  
this.pageSizes=event.value;
this.viewLogsDetails()
}


  viewLogsDetails() {
    console.log("inside");
    this.httpService.callGetService(`${this.config.viewLogsForExitUpdate}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}&page=${this.pageNo - 1}&size=${this.pageSizes}`)
      .subscribe((result: any) => {
        this.updateLogs = result.data?.logs;

      });
  }





page = 1;
pageSize = 10;
  get paginatedData() {
    const start = (this.page - 1) * this.pageSize;
    return this.updateLogs.slice(start, start + this.pageSize);
  }

  get totalPages() {
    return Math.ceil(this.updateLogs.length / this.pageSize);
  }

}
